import { getReportStatusLabel } from './getReportStatusLabel'

interface Props {
  name: string
}

export const ReportStatusLabel = ({ name }: Props) => <span>{getReportStatusLabel(name)}</span>
